import React from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Oval } from "react-loader-spinner";
import LabelForm from "pages/signup/form/labelForm";
import InputComponent from "components/input";
import { validateEmail } from "utils/helper";
import BGShutterstock from "images/auth/bg-shutterstock.png";
import { ReactComponent as TVendorIcon } from "images/auth/t-vendors.svg";
import useInviteAssignees from "./useInviteAssignees";
import { ReactComponent as ApprovedImage } from "images/externalPage/high-five.svg";
import { ReactComponent as DeclineImage } from "images/externalPage/decline-image.svg";

const InviteAssignees = () => {
  const [t] = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const {
    navigate,
    isLoading,
    emailParam,
    onInviteAssignee,
    successMsg,
    isAccept,
  } = useInviteAssignees();

  const handleInviteAction = (isAccept) => {
    return (data) => {
      onInviteAssignee(data, isAccept);
    };
  };

  return (
    <form onSubmit={handleSubmit(handleInviteAction(true))}>
      <div
        className="w-full h-[100px] bg-no-repeat  bg-cover bg-center flex items-center px-[20%] xl-max:px-[10%] lg-max:px-[2rem] md-max:px-[1rem] fixed z-[999999999]"
        style={{
          backgroundImage: `url(${BGShutterstock})`,
          zIndex: 100,
        }}
      >
        <div className="max-w-[843px] w-full flex items-center justify-between">
          <TVendorIcon
            onClick={() => navigate("/login")}
            className="cursor-pointer"
          />
        </div>
      </div>
      {!successMsg ? (
        <div className="mt-[220px] px-[35%] xl-max:px-[10%] lg-max:px-[2rem] md-max:px-[1rem] flex flex-col mb-[97px] relative min-h-[calc(100vh-750px)]">
          <LabelForm
            label={t("taskInvitation")}
            labelClassName="text-primary font-bold text-[28px] md-max:text-[20px] not-italic mb-[30px] text-center"
          />

          <LabelForm
            label={t("interestedTaskMsg")}
            labelClassName="text-primary font-bold text-[20px] md-max:text-[16px] not-italic"
          />

          {!emailParam && (
            <InputComponent
              label={t("emailTitle")}
              isRequired={true}
              type="email"
              name="email"
              placeholder={t("placeholder", {
                field: t("emailTitle").toLowerCase(),
              })}
              errorMessage={errors.email ? errors.email.message : ""}
              register={register}
              registerArgs={{
                required: t("errorField", { field: t("emailTitle") }),
                validate: validateEmail,
              }}
              autoFocus={true}
              labelClassName="text-primary font-semibold text-[16px] mt-[20px]"
              inputClassName={`flex h-[43px] min-w-[250px] sm-max:w-full items-center gap-[8px] self-stretch rounded-[6px] border-[1px] border-solid ${
                errors.email ? "border-red" : "border-default-color"
              } bg-transparent outline-none text-dark-gray font-regular text-[16px] not-italic  placeholder:font-regular placeholder:text-[16px] placeholder:not-italic placeholder:font-normal py-[16px] px-[14px]`}
            />
          )}

          <div className="flex items-center justify-center gap-[10px] mt-[40px]">
            <button
              type="button"
              onClick={handleSubmit(handleInviteAction(false))}
              disabled={isLoading.reject}
              className="cursor-pointer flex py-[14px] px-[16px] gap-[8px] justify-center items-center rounded-[6px] border-[1px] border-solid border-default-color bg-white h-[46px] w-[150px]"
            >
              <Oval
                height={30}
                width={30}
                color="#000000"
                visible={isLoading.reject}
                ariaLabel="oval-loading"
                secondaryColor="#000000"
                strokeWidth={5}
                strokeWidthSecondary={3}
              />
              <div className="text-base-black font-bold text-[16px] not-italic">
                {t("reject")}
              </div>
            </button>
            <button
              type="submit"
              disabled={isLoading.accept}
              className="cursor-pointer flex py-[14px] px-[16px] gap-[8px] justify-center items-center rounded-[6px] border-[1px] border-solid border-primary bg-primary h-[46px] w-[150px]"
            >
              <Oval
                height={30}
                width={30}
                color="#FFF"
                visible={isLoading.accept}
                ariaLabel="oval-loading"
                secondaryColor="#FFF"
                strokeWidth={5}
                strokeWidthSecondary={3}
              />
              <div className="text-white font-bold text-[16px] not-italic">
                {t("accept")}
              </div>
            </button>
          </div>
        </div>
      ) : (
        <div className="mt-[220px] px-[10%] xl-max:px-[10%] lg-max:px-[2rem] md-max:px-[1rem] flex flex-col mb-[97px] relative min-h-[calc(100vh-750px)] items-center justify-center">
          {isAccept ? <ApprovedImage /> : <DeclineImage />}
          <LabelForm
            label={t(successMsg)}
            labelClassName="text-primary font-bold text-[22px] md-max:text-[18px] not-italic ml-[15px]"
          />
        </div>
      )}
    </form>
  );
};

export default InviteAssignees;
